module.exports = __webpack_public_path__ + "static/media/STAF_bokmål og sørsamisk_sekundærlogo_pos(svart).e0c43511.png";